module.exports = __webpack_public_path__ + "img/Ikro.367cce22.jpeg";